"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleSaveSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleSaveSchema extends baseClickSchema_1.BaseClickSchema {
    constructor() {
        super({ componentName: 'FreeModuleModalSaveButton' });
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_SAVE;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action
        };
    }
}
exports.ClickFreeModuleSaveSchema = ClickFreeModuleSaveSchema;
